import echart, { EChartOption, EChartsResponsiveOption, ECharts } from 'echarts'
import { getTitleStringByType } from '@/utils/date'

export const drawMapChart = (chart: ECharts, data: any, filter:any) => {
  chart.setOption({
    title: {
      text: `全疆加气站(${getTitleStringByType(filter)})`
    },
    tooltip: {
      trigger: 'item',
      formatter: (params:any) => {
        let data = params.data.data
        return `气站名称：${data.name}<br/>消费总计：${parseFloat(data.total).toFixed(2)}￥<br/>消费人次：${data.count}`
      }
    },
    geo: {
      map: 'xinjiang',
      roam: false,
      label: {
        show: false,
        color: '#fff',
        emphasis: {
          show: true,
          color: '#fff'
        }
      },
      itemStyle: {
        normal: {
          areaColor: '#65d186' // 地图颜色
        //   borderColor: '#6367ad',
        //   borderWidth: 1
        }
        // emphasis: {
        //   areaColor: '#feb6aa' // hover效果
        // }
      },
      left: '5%',
      right: '5%',
      top: '5%',
      bottom: '5%'
    },
    series: [{
      name: 'xinjiang',
      type: 'scatter',
      coordinateSystem: 'geo',
      symbolSize: function(val: any) {
        return 8
      },
      data: data.map((item:any) => {
        return {
          name: item.name,
          value: [parseFloat(item.longitude), parseFloat(item.latitude), 1],
          data: item
        }
      })
    }]
  })
}
